<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>
    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <stage-comment-item></stage-comment-item>

    <div class="margin_top_20">
      <div v-show="firstStage" class="margin-left-10 margin-right-10">
        <weex-text class="item-bold-lg-heading">{{attachDocumentTitle}}</weex-text>
        <div v-if="attachDocumentDescription" class="margin-top-10">
          <weex-text class="item-heading">{{attachDocumentDescription}}</weex-text>
        </div>

        <image-capture-item
          class="margin_top_20"
          @fileAttached="fileAttached"
          :image-activity-type="imageActivityType"
        >
        </image-capture-item>
      </div>

      <div v-show="!firstStage" class="margin-left-10 margin-right-10">
        <weex-text class="item-bold-lg-heading">{{documentUploadedTitle}}</weex-text>
        <div v-if="documentUploadedDescription"
             class="margin-top-10">
          <weex-text class="item-base-description text-color-gray">{{documentUploadedDescription}}</weex-text>
        </div>
        <show-file-item
          class="margin_top_20"
          ref="showFileItem"
          :image-src="imageSrc">
        </show-file-item>
        <div class="margin_top_20" @click="reAttachDocumentClicked">
          <weex-text class="item-base-link text-align-center">{{reUploadDocumentText}}</weex-text>
        </div>

        <div class="input_container" v-if="identifierRequired">
          <weex-text class="input_label">{{identifierLabel}}</weex-text>
          <input
              :readonly="true"
              class="input_with_border_bottom"
              :value="identifier"
              @input="identifierValue=$event.target.value">
        </div>
      </div>

      <wxc-button
        v-if="!firstStage"
        text="Continue"
        class="horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="saveAndMoveNext">
      </wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from '../../layout/ToolBar'
import Loading from '../../layout/Loading'
import WxcButton from "@/../weex-ui/packages/wxc-button/index"
import { Constants } from '@/components/Constants'
import LoanTaskActivityNavigator from '@/utils/LoanTasksActivityNavigator'
import DataSource from '@/data/DataSource'
import ErrorAlertItem from '@/components/layout/ErrorAlertItem'
import ImageCaptureItem from '@/components/layout/ImageCaptureItem'
import ShowFileItem from '@/components/layout/ShowFileItem'
import AlertService from "@/components/core/alert/AlertService";
import { MessageConstants } from "@/utils/MessageConstantUtil";
import { environment } from "@/environments/environment"
import StageCommentItem from "../../layout/StageCommentItem";

export default {
  name: 'ImageActivity',
  components: {
    ErrorAlertItem,
    ToolBar,
    WxcButton,
    Loading,
    ImageCaptureItem,
    ShowFileItem,
    StageCommentItem
  },
  data: () => ({
    firstStage: true,
    identifierValue: '',
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    documentId: -1
  }),
  props: {
    toolbarTitle: {
      type: String,
      required: true
    },
    attachDocumentTitle: {
      type: String,
      default: 'Attach a Document'
    },
    attachDocumentDescription: {
      type: String,
      default: ''
    },
    documentUploadedTitle: {
      type: String,
      default: 'Document Uploaded'
    },
    documentUploadedDescription: {
      type: String,
      default: ''
    },
    reUploadDocumentText: {
      type: String,
      default: 'Upload New Image'
    },
    allowDocumentFromGallery: {
      type: Boolean,
      default: false
    },
    uploadToMifos: {
      type: Number,
      required: true
    },
    imageActivityType: {
      type: Number,
      required: true,
      default: 0x0
    },
    directory: {
      type: String,
      required: true
    },
    entityType: {
      type: String,
      required: true
    },
    entityId: {
      type: Number,
      required: true,
      default: 0
    },
    identifierRequired: {
      type: Boolean,
      default: false
    },
    identifierLabel: {
      type: String,
      default: ''
    },
    identifier: {
      type: String,
      default: ''
    },
    tasks: {
      type: Array,
      required: true,
      default: () => ['IMAGE']
    }
  },
  methods: {
    fileAttached(file) {
      this.uploadFile(file)
    },

    uploadFile(file) {
      if (this.imageActivityType === Constants.SELFIE_IMAGE_ACTIVITY) {
        this.loading = true
        DataSource.uploadClientImage(this.entityId, this.directory.toUpperCase(), file)
          .then(uploadFileRes => {
            this.loading = false
            if (uploadFileRes.errorOccurred) {
              this.showError(uploadFileRes.data)
            } else {
              this.showToast(MessageConstants.DOCUMENT_UPLOADED)
              this.firstStage = false
              this.$refs.showFileItem.showFile()
            }
          })
      } else if (this.uploadToMifos === Constants.UPLOAD) {
        this.loading = true
        DataSource.createDocument(this.entityType, this.entityId, this.directory.toUpperCase(),
          Constants.getDescription(this.directory), this.directory, file)
          .then(uploadFileRes => {
            this.loading = false
            if (uploadFileRes.errorOccurred) {
              this.showError(uploadFileRes.data)
            } else {
              this.documentId = uploadFileRes.data.resourceId;
              this.showToast(MessageConstants.DOCUMENT_UPLOADED)
              this.firstStage = false
              this.$refs.showFileItem.showFile()
            }
          })
      } else if (this.imageActivityType === Constants.PAN_IMAGE_IMAGE_ACTIVITY) {
        //TODO handle it properly
        if (this.imageActivityType === Constants.PAN_IMAGE_IMAGE_ACTIVITY) {
          this.loading = true;
          DataSource.createDocument(
            this.entityType, this.entityId, this.directory.toUpperCase(),
            Constants.getDescription(this.directory), this.directory, file
          ).then(uploadFileRes => {
            this.loading = false;
            if (uploadFileRes.errorOccurred) {
              this.$emit('uploadFailed')
              this.showError(uploadFileRes.data)
            } else {
              this.showToast(MessageConstants.DOCUMENT_UPLOADED)
              this.documentId = uploadFileRes.data.resourceId;
              this.firstStage = false
              this.$refs.showFileItem.showFile()
              const identifier = this.identifierValue
              const fileName = ''
              // this.$emit('onPanDocumentUploaded', { identifier, fileName })
            }
          })
        }
      }
    },

    reAttachDocumentClicked() {
      this.firstStage = true
    },

    saveAndMoveNext() {
      //TODO upload identifier if needed
      this.getNextTask()
    },

    showError(error) {
      this.loading = false
      this.networkError = error
      this.errorAlertEvent = true
    },

    showToast(message) {
      AlertService.showToast(message)
    },

    getNextTask() {
      this.loading = true
      LoanTaskActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false
          if (res.errorOccurred) {
            this.showError(res.data)
          }
        })
    }
  },

  computed: {
    imageSrc() {
      if (Constants.SELFIE_IMAGE_ACTIVITY === this.imageActivityType) {
        return `${environment.serverUrl}/${this.entityType}/${this.entityId}/images?tenantIdentifier=default&output=inline_octet&maxHeight=50`
      } else {
        return `${environment.serverUrl}/${this.entityType}/${this.entityId}/documents/${this.documentId}/attachment?tenantIdentifier=default&output=inline_octet&maxHeight=50`
      }
    },
  }
}
</script>

<style scoped src="../../../assets/style/base.css"></style>

